import { createAsyncThunk } from '@reduxjs/toolkit'
import PlayerInvite from './player-invite-model'
import {
  delete_playerInvite,
  load_playerInvites,
  store_playerInvite,
} from './playerInvite-service'

export const LoadPlayerInvitesAsync = createAsyncThunk<any, any>(
  'composer/load/playerInvite',
  async (params: { uid: string }) => {
    return await load_playerInvites(params)
  },
)

export const CreatePlayerInviteAsync = createAsyncThunk<any, any>(
  'composer/create/playerInvite',
  async (params: PlayerInvite) => {
    return await store_playerInvite(params)
  },
)

export const DeletePlayerInviteAsync = createAsyncThunk<any, any>(
  'composer/delete/playerInvite',
  async (params) => {
    return await delete_playerInvite(params)
  },
)
